export const formatNumber = (value?: number | null): string => {
  if (value == null) return '';

  // Al no indicar un locale como "en-US" o "es-PA", JavaScript
  // usa la configuración regional del navegador.
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

export const formatCurrency = (value?: number | null, currency = 'USD'): string => {
  if (value == null) return '';

  // Al no indicar un locale como "en-US" o "es-PA", JavaScript
  // usa la configuración regional del navegador.
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  }).format(value);
};
